import type { WorkshopLifecycle } from '../../../api/workshops';

/** A published workshop has been live: its schedule and type are locked, and its
 *  roster and check-in stay open whether or not its sales are disabled. */
export function isPublished(lifecycle: WorkshopLifecycle): boolean {
  return lifecycle === 'active' || lifecycle === 'disabled';
}
